import React from 'react';
import Header from "../components/Header";
import Footer from "../components/Footer";
// import Contactsection from '../components/Contactsection';
import Contactsection from '../components/Contactsection';
import PageMeta from '../components/PageMeta';

const Contactpage = () => {
  return (
    <>
    <PageMeta
      title="Contact Us - GuestLinkup"
      description="Get in touch with GuestLinkup for questions about bookings, listings, or partnering as a homestay owner."
    />
    <Header />
      <Contactsection />
      <Footer />
      </>
  )
}

export default Contactpage